export const EMAIL_PROFILE_NAVIGATION_DIRECT_LINK_COUNTER = {
  index: 1,
  total: 1,
}
